/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getSearchFilterConfigRpc = {
  serviceName: 'com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontRpc',
  rpcName: 'getSearchFilterConfig',
  auth: 'app',
  fingerprint: '4oEIKcmmEbn0sn8Orm55J5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPaginatedSearchFilterOptionsRpc = {
  serviceName: 'com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontRpc',
  rpcName: 'getPaginatedSearchFilterOptions',
  auth: 'app',
  fingerprint: 'unUTtSH07dxWJI26PehUypwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};